export default class Frame {
  public id: string = ''
  public price: number = 0
  public selected: boolean = false
}
